import { AgChartOptions } from 'ag-charts-enterprise';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import franceGeoJson from '../../assets/map/france';
import { siteTypeEnum } from '../../constants/enums/site';
import { useSitesQuery } from '../../hooks/queries/useSitesQuery';
import { capitalizeFirstLetter } from '../../utils/capitalize';
import GenericAgChart from './GenericAgChart';
import { useEntitiesQuery } from '../../hooks/queries/useEntitiesQuery';

interface SitesMapChartProps {}

const SitesMapChart: React.FC<SitesMapChartProps> = ({}) => {
    const { t } = useTranslation();

    const { data: dataSites } = useSitesQuery({ queries: { active: true } });
    const { data: dataEntities } = useEntitiesQuery({ queries: { active: true } });

    const options = useMemo<AgChartOptions | null>(() => {
        if (!franceGeoJson || !dataSites?.length) return null;

        const cleanSites = dataSites.filter(
            (site) =>
                typeof site.latitude === 'number' &&
                typeof site.longitude === 'number' &&
                !isNaN(site.latitude) &&
                !isNaN(site.longitude) &&
                site.latitude !== 0 &&
                site.longitude !== 0 &&
                site.type === siteTypeEnum.INTERNAL
        );

        const cleanEntities = dataEntities?.filter(
            (entity) =>
                typeof entity.latitude === 'number' &&
                typeof entity.longitude === 'number' &&
                !isNaN(entity.latitude) &&
                !isNaN(entity.longitude) &&
                entity.latitude !== 0 &&
                entity.longitude !== 0
        );

        return {
            topology: franceGeoJson,
            padding: { top: 0, right: 0, bottom: 0, left: 0 },

            series: [
                {
                    type: 'map-shape-background',
                },
                {
                    type: 'map-marker',
                    title: 'Chantiers',
                    data: cleanSites,
                    shape: 'pin',
                    size: 15,
                    fillOpacity: 1,
                    longitudeKey: 'longitude',
                    latitudeKey: 'latitude',
                    labelKey: 'name',
                    label: {
                        enabled: false,
                    },
                    labelName: capitalizeFirstLetter(t('name')),
                    tooltip: {
                        renderer: (params) => {
                            return {
                                heading: params.datum.name,
                            };
                        },
                    },
                },
                {
                    type: 'map-marker',
                    title: 'Entités',
                    data: cleanEntities,
                    shape: 'triangle',
                    size: 12,
                    fill: '#000000',
                    stroke: '#FFFFFF',
                    strokeWidth: 1,
                    fillOpacity: 1,
                    longitudeKey: 'longitude',
                    latitudeKey: 'latitude',
                    labelKey: 'designation',
                    label: {
                        enabled: false,
                    },
                    labelName: capitalizeFirstLetter(t('designation')),
                    tooltip: {
                        renderer: (params) => {
                            return {
                                heading: params.datum.name,
                            };
                        },
                    },
                },
            ],
        };
    }, [franceGeoJson, dataSites, dataEntities, t]);

    return <GenericAgChart options={options} />;
};

export default SitesMapChart;
